import { render } from "./todayVisitFollowUp.vue?vue&type=template&id=4d66bae5&scoped=true"
import script from "./todayVisitFollowUp.vue?vue&type=script&lang=js"
export * from "./todayVisitFollowUp.vue?vue&type=script&lang=js"

import "./todayVisitFollowUp.vue?vue&type=style&index=0&id=4d66bae5&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d66bae5"]])

export default __exports__